import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteData, getData, patchData } from '../Services/api'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import avtar1 from '../../assets/images/user/avatar-1.jpg';
import Pagination from '../Services/Pagination'

const CategoryList = () => {
    const [catList, setCatList] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const fetchCategories = async (pageNumber = 1,) => {
        try {
            const res = await getData(`/category?page=${pageNumber}`);
            if (res.status) {
                setCatList(res.data || []);
                setPage(res.pagination.currentPage);
                setPages(res.pagination.totalPages);
                setTotal(res.pagination.totalCategories);
            }
        } catch (error) {
            console.log("error fetch categroy", error)
        }
    }

    useEffect(() => {
        fetchCategories(page);
    }, [page]);
    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            fetchCategories(pageNumber);
        }
    };
    const handleStatusChange = async (id) => {
        try {
            const res = await patchData(`/category/toggle/${id}`);
            if (res.status) {
                toast.success(res.message);
                fetchCategories();
            }
        } catch (error) {
            console.log("error categroy status change", error)
        }
    }

    const handleDelete = (slug) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/category/${slug}`,);
                    if (res.status) {
                        toast.success(res.message);
                        fetchCategories();
                    }
                } catch (error) {
                    console.log("error delete categroy", error)
                }
            }
        });
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/categories/category-list">Category</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Category List
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Category List</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="card-body">
                                    <div className="text-end pb-sm-2 p-4">
                                        <Link
                                            to="/categories/add-category"
                                            className="btn btn-primary d-inline-flex align-item-center"
                                        >
                                            <i className="fas fa-plus f-18 me-2" /> Add Category
                                        </Link>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Image</th>
                                                    <th>Category Name</th>
                                                    <th>Status</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    catList?.length > 0 ? (
                                                        catList?.map((cms, index) => {
                                                            return (
                                                                <tr key={cms._id}>
                                                                    <td>{index + 1}.</td>
                                                                    <td>
                                                                        <div className="row">
                                                                            <div className="col-auto">
                                                                                <img
                                                                                    src={cms?.cat_image ? `${cms.cat_image}` : avtar1}
                                                                                    alt="user-image"
                                                                                    className="wid-40 rounded-circle"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <h6 className="mb-0">{cms.cat_name}</h6>
                                                                    </td>
                                                                    <td>
                                                                        <div className="form-check form-switch p-0">
                                                                            <input
                                                                                className="form-check-input h4 position-relative m-0"
                                                                                type="checkbox"
                                                                                role="switch"
                                                                                checked={cms.status}
                                                                                onChange={() => handleStatusChange(cms._id)}
                                                                            />
                                                                        </div>

                                                                    </td>
                                                                    <td className="text-center">
                                                                        <ul className="list-inline me-auto mb-0">
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="View"
                                                                            >
                                                                                <Link
                                                                                    to={`/categories/view-category/${cms._id}`}
                                                                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-eye f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Edit"
                                                                            >
                                                                                <Link
                                                                                    to={`/categories/update-category/${cms._id}`}
                                                                                    className="avtar avtar-xs btn-link-success btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-edit f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Delete"
                                                                            >
                                                                                <a
                                                                                    onClick={() => handleDelete(cms._id)}
                                                                                    className="avtar avtar-xs btn-link-danger btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-trash f-18" />
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={6} className='text-center'>No Category Found</td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                        <div className="text-muted">
                                            Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                                        </div>
                                        <Pagination
                                            page={page}
                                            pages={pages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CategoryList